import React from "react";
import { Box, Container, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import bgImage from "../Images/UlapRecPictures/Laptop.png";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#FF7707",
    color: "#fff",
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0, 
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(6),
      marginTop: theme.spacing(2),
    },
  },
  container: {
    marginTop: 0,
    paddingTop: 0,
  },
  contentBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      textAlign: "center",
    },
  },
  imageBox: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    marginTop: theme.spacing(-4), 
    [theme.breakpoints.up("md")]: {
      marginBottom: 0,
    },
  },
  image: {
    maxWidth: "100%",
    height: "auto",
    transform: "translateY(30%)",
    [theme.breakpoints.down("sm")]: {
      transform: "translateY(0)",
      maxWidth: "70%",
    },
  },
  textBox: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 0,
    paddingLeft: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
      paddingTop: theme.spacing(3),
    },
  },
  title: {
    fontWeight: "bold",
    fontSize: "28px",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: "24px",
    },
  },
  description: {
    fontSize: "1rem",
    marginBottom: theme.spacing(2),
    textAlign: "center",
  },
  button: {
    width: "50%",
    backgroundColor: "#fff",
    color: "#ff6a00",
    "&:hover": {
      backgroundColor: "#f2f2f2",
    },
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
  },
}));

function BeforeFooter() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Container className={classes.container}>
        <Box className={classes.contentBox}>
          <Box className={classes.imageBox}>
            <img src={bgImage} alt="Devices" className={classes.image} />
          </Box>
          <Box className={classes.textBox}>
            <Typography className={classes.title}>
              GET SEEN BY TOP TALENT IN MINUTES!
            </Typography>
            <Typography className={classes.description}>
              Connect with qualified applicants looking for their next opportunity.
            </Typography>
            <Button className={classes.button} variant="contained">
              Post a Job
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default BeforeFooter;
